module.exports = __webpack_public_path__ + "img/data4.17edad9a.png";